<template>
  <v-container>
    <!-- 検索エリア -->
    <v-row class="mt-2">
      <v-col cols="auto" sm="auto" md="auto" lg="auto">
        <h2>冷媒調査一覧</h2>
      </v-col>
      <v-col cols="auto" sm="auto" md="auto" lg="1">
        <YearPicker
          label="対象年度"
          v-model="searchCondition.targetYear"
          format="YYYY"
          selectType="month"
          :clearable="false"
          :hideDetails="true"
          suffix="年度"
          :changeEvt="search"
          :loading="loading"
        ></YearPicker>
      </v-col>
      <v-col cols="2">
        <v-text-field 
          label="会社名"
          v-model="searchCondition.companyName" 
          dense 
          :rules="[maxLength(50)]" 
          :maxlength="50"
          :disabled="loading"
          :clearable="true"
          :loading="loading"
          @change="search"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field 
          label="事業所名"
          v-model="searchCondition.officeName" 
          dense 
          :rules="[maxLength(50)]" 
          :maxlength="50"
          :disabled="loading"
          :clearable="true"
          :loading="loading"
          @change="search"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-select
          label="ステータス"
          v-model="searchCondition.status"
          :items="ansStatus"
          dense
          :disabled="loading"
          :clearable="true"
          :loading="loading"
          @change="search"
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-col v-if="attribute == 2" cols="auto" sm="auto" md="auto" lg="auto">
        <div class="d-flex justify-end">
          <v-btn class="mr-2" color="primary"  :disabled="loading" @click="showChangeAnsPeriod()">回答受付期間一括変更</v-btn>
          <v-btn class="mr-2" color="primary"  :disabled="loading" @click="showChangeStatus()">ステータス一括変更</v-btn>
          <v-btn class="" color="primary" :disabled="loading" @click="getRefrigerantDB()"><v-icon :small="true">mdi-download</v-icon>集計表ダウンロード</v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-data-table 
          ref="ref"
          :headers="headers" 
          :items="officeList" 
          :loading="loading" 
          :dense="true" 
          :items-per-page="10" 
          :mobile-breakpoint="0" 
          :disable-pagination="true" 
          :hide-default-footer="true" 
          :fixed-header="true" 
          locale="ja-jp" 
          loading-text="読込中" 
          no-data-text="データがありません。" 
          class="sticky_table table-border"
          :custom-filter="customFilter"
        >
          <template v-slot:item="{ item, index }">
            <!-- <tr :key="index" :class="[item.memberNo == memberNo ? 'selected-color' : '']"> -->
            <tr :key="index">
              <td class="center">
                {{ item.companyId }}
              </td>
              <td class="center">
                {{ item.memberNo }}
              </td>
              <td class="left">
                {{ item.companyName }}
              </td>
              <td class="left">
                {{ item.officeName }}
              </td>
              <td class="left">
                <v-text-field
                  v-model="item.branchName"
                  hide-details
                  dense
                  class="mb-1"
                  @input="item.branchEdit=true"
                  @change="saveBranch(item)"
                  :rules="[maxLength(200)]"
                  :maxlength="200"
                  :readonly="attribute == 0 && item.status >= 3"
                  :disabled="loading"
                ></v-text-field>
              </td>
              <td class="left">
                <v-text-field
                  v-model="item.address"
                  hide-details
                  dense
                  class="mb-1"
                  @input="item.branchEdit=true"
                  @change="saveBranch(item)"
                  :rules="[maxLength(200)]" 
                  :maxlength="200"
                  :readonly="attribute == 0 && item.status >= 3"
                  :disabled="loading"
                ></v-text-field>
              </td>
              <td class="left">
                {{item.ansPeriodFrom | formatDateW}} ～ {{item.andPeriodTo | formatDateW}}<span v-if="!isBetweenDate(item.ansPeriodFrom, item.andPeriodTo)" class="text-error">受付期間外</span>
              </td>
              <td v-if="attribute == 0" class="center">
                {{getAnsStatusText(item.status)}}
              </td>
              <td v-else class="center">
                <v-select
                  v-model="item.status"
                  :items="ansStatus"
                  hide-details
                  dense
                  @input="item.branchEdit=true"
                  @change="saveBranch(item)"
                  :readonly="attribute == 0"
                  :clearable="false"
                  :disabled="loading"
                ></v-select>
              </td>
              <td>
               {{ item.ansRemarks }}
              </td>
              <td class="center">
                <v-btn small class="primary" :height="20" :width="100" :disabled="loading || item.branchEdit" @click="gotoDetail('RefrigerantEdit', item.sid, item.memberNo, item.branch, item.branchName, item.address)">
                  <v-icon v-if="item.status == 0" :small="true">mdi-border-color</v-icon>
                  <v-icon v-else-if="item.status == 1" :small="true">mdi-alert</v-icon>
                  <v-icon v-else :small="true">mdi-chevron-down-circle</v-icon>
                  {{item.status == 0 ? '回答する' : 
                    item.status == 1 ? '回答編集' : 
                    item.status == 2 ? '回答済み' : 
                    item.status == 3 ? '確定済み' :
                    item.status == 4 ? '確認中' :
                    item.status == 5 ? '保留中' :
                                        '確認済み'}}
                </v-btn>
                <v-btn v-if="item.branch == getFirstBranch(item.memberNo)" small class="primary ml-1" :height="20" :width="100" :disabled="loading" @click="addBranch(index, item)">
                  区別追加
                </v-btn>
                <!-- <v-btn v-else small class="primary ml-1" :height="20" :width="100" :disabled="loading || !item.branchEdit" @click="saveBranch(item)">
                  区別保存
                </v-btn> -->
                <v-btn v-else small class="secondary ml-1" :height="20" :width="100" :disabled="loading" @click="deleteBranch(item)">
                  区別削除
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    
    <!------------------------------------------------------------------------>
    <!-- ぐるぐる -->
    <modal name="modal-dialog" :draggable="false" :clickToClose="false" :scrollable="true" height="auto" id="vm--modal">
      <div>
        <h3 class="center mt-5 action-message">{{actionMessage}}</h3> 
        <Spinner size="150" class="spinner" ></Spinner>
      </div>
    </modal>

    <!------------------------------------------------------------------------>
    <!-- ステータス一括変更 -->
    <modal name="change-status-modal-dialog" :draggable="false" :clickToClose="true" :scrollable="true" 
                                height="200px" width="50%" id="vm--modal-import">
      <div class="modal-wrap">
        <div class="d-flex modal-header mt-8 pb-8 justify-space-between">
          <h2>ステータス一括変更</h2>
          <v-icon x-large v-on:click="hideChangeStatus()" :disabled="loading">mdi-close-circle</v-icon>
        </div>
        <div class="modal-body">
          <v-container>
            <v-row class="">
              <v-col cols="12">
                ステータスを選択してください。
              </v-col>
            </v-row>
            <v-row class="justify-space-between">
              <v-col cols="8">
                <v-select
                  label="ステータス"
                  v-model="bulkStatus"
                  :items="ansStatus"
                  dense
                  :clearable="false"
                  :loading="loading"
                ></v-select>
              </v-col>
              <v-col cols="4" class="d-flex justify-end">
                <v-btn 
                  class="btn_font primary mr-2" 
                  v-on:click="saveBulkStatus()"
                  :disabled="loading || (bulkStatus == null)" >
                  ステータス一括変更
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </modal>

    <!------------------------------------------------------------------------>
    <!-- 回答受付期間一括変更 -->
    <modal name="change-ans-period-modal-dialog" :draggable="false" :clickToClose="true" :scrollable="true" 
                                height="200px" :width="modalWidth" id="vm--modal-import">
      <div class="modal-wrap">
        <div class="d-flex modal-header mt-8 pb-8 justify-space-between">
          <h2>回答受付期間一括変更</h2>
          <v-icon x-large v-on:click="hideChangeAnsPeriod()" :disabled="loading">mdi-close-circle</v-icon>
        </div>
        <div class="modal-body">
          <v-container>
            <v-row class="">
              <v-col cols="12">
                回答受付期間を選択してください。
              </v-col>
            </v-row>
            <v-row class="justify-space-between">
              <v-col class="d-flex align-center" cols="8">
                <DatePicker
                  label="回答受付期間 開始"
                  v-model="bulkAnsPeriodFrom"
                  format="YYYY/MM/DD"
                  selectType="date"
                  :rules="[checkStartEndDate(bulkAnsPeriodFrom, bulkAnsPeriodTo)]"
                  :clearable="false"
                  :loading="loading"
                ></DatePicker>
                ～
                <DatePicker
                  label="回答受付期間 終了"
                  v-model="bulkAnsPeriodTo"
                  format="YYYY/MM/DD"
                  selectType="date"
                  :rules="[checkStartEndDate(bulkAnsPeriodFrom, bulkAnsPeriodTo)]"
                  :clearable="false"
                  :loading="loading"
                ></DatePicker>
              </v-col>
              <v-col cols="4" class="d-flex justify-end">
                <v-btn 
                  class="btn_font primary mr-2" 
                  v-on:click="saveBulkAnsPeriod()"
                  :disabled="loading || (bulkAnsPeriodFrom == null || bulkAnsPeriodTo == null)" >
                  回答受付期間一括変更
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </modal>
  </v-container>
</template>

<script>
import Debug from "../Lib/Debug";
import Message from "../Lib/Message";
import YearPicker from "./common/YearPicker.vue";
import DatePicker from "./common/DatePicker.vue";

import dayjs from "dayjs";
import Mixin from "../mixins/const.js";
import Download from "../model/download";
import Spinner from 'vue-simple-spinner'
import saveAs from "file-saver";

import Refrigerant from "../model/refrigerant";
import RefrigerantAnswer from "../model/refrigerantAnswer";
import RefrigerantDest from "../model/refrigerantDest.js";

export default {
  components: {
    YearPicker,
    DatePicker,
    Spinner,
  },

  mixins: [Mixin],

  data: () => ({
    valid: true,
    loading: false,

    show: true,

    memberNo: '',
    attribute: 0,

    // テーブルヘッダー
    headers: [
      { text: "登録番号", align: "center", sortable: true, value: "companyId", width: "80px" },
      { text: "会員番号", align: "center", sortable: true, value: "memberNo", width: "80px" },
      { text: "会社名", align: "center", sortable: true, value: "companyName", width: "150px" },
      { text: "事業所名", align: "center", sortable: true, value: "officeName", width: "150px" },
      { text: "区別(棟)", align: "center", sortable: true, value: "branchName", width: "100px" },
      { text: "所在地", align: "center", sortable: true, value: "address", width: "220px" },
      { text: '回答受付期間', align: 'center', sortable: true, value: 'ansPeriodFromTo', width: "130px" },
      { text: "ステータス", align: "center", sortable: true, value: "status", width: "130px" },
      { text: "備考", align: "center", sortable: true, value: "ansRemarks", width: "220px" },
      { text: "", align: "center", sortable: false, value: "action", width: "220px" },
    ],

    // 回答データ一覧
    officeList: [],

    // 検索条件
    searchCondition: {
      screenType: 'RefrigerantList',
      companyId: null,
      associationId: null,
      companyName: '',
      officeName: '',
      targetYear: '',
      searchString: null,
      status: null,
    },

    // ぐるぐるメッセージ
    actionMessage: '',

    // 一括変更ステータス
    bulkStatus: null,

    // 一括変更回答期間
    bulkAnsPeriodFrom: null,
    bulkAnsPeriodTo: null,
  }),

  // ライフサイクルフック
  created: function () {
    this.attribute = this.$store.getters.getAttribute;  // 属性
    if(this.attribute == 0) {
      // 事業所ユーザ
      this.memberNo = this.$store.getters.getMemberNo;    // 会員番号
    } else {
      // 協会ユーザ
      this.memberNo = this.$store.getters.getAssociation.association_id;    // 会員番号
    }
    
    const str = this.$store.getters.getStoreSearchCondition;
    if (str.screenType == 'RefrigerantList') {
      // 回答画面から戻った場合
      this.searchCondition = str;
    } else {
      // 初期値
      const params = this.$route.params;
      if('targetYear' in params) {
        // 回答状況チェックから
        this.searchCondition.targetYear = params.targetYear;
      } else {
        // メニューから
        this.searchCondition.targetYear = dayjs().format().substr(0, 7);  // 実施年(YYYY-MM)
      }
    }

    // 属性による検索条件の設定
    if(this.attribute == 0) {
      // 事業所ユーザは自会社の事業所データのみ
      this.searchCondition.companyId = this.$store.getters.getCompanyId;

      // 事業所ユーザは、自分がメール宛先にある場合のみ
      this.searchCondition.email = this.$store.getters.getUserid;

    } else if(this.attribute == 1) {
      // 都道府県協会ユーザは自協会に所属する会社のデータのみ
      this.searchCondition.associationId = this.memberNo;
    }

    this.loadList(); // 表示更新
  },

  mounted: async function () {},

  methods: {
    /** 表示更新 */
    async loadList() {
      Debug.log("function[loadList]");
      this.loading = true;

      // this.companyId = this.$store.getters.companyId; // 会社IDをstoreから取得
      try {
        //const res = await Refrigerant.getData(this.companyId, this.targetYear);
        const res = await Refrigerant.search(this.searchCondition);
        Debug.log(res.data);
        this.officeList = res.data;
      } catch (error) {
        Message.err(error, "冷媒調査一覧を取得できませんでした");
      }

      Debug.log(this.officeList);
      this.loading = false;
    },

    search() {
      Debug.log("function[search]");
      this.$store.commit('setStoreSearchCondition', this.searchCondition);
      this.loadList();
    },

    /** 詳細ページに遷移 */
    gotoDetail(name, surveyId, memberNo, branch, branchName, address) {
      Debug.log("function[gotoDetail]");
      this.$store.commit("setTargetSurveyId", surveyId); // クリックした調査IDをstoreに保存
      this.$store.commit("setTargetMemberNo", memberNo); // クリックした会員番号をstoreに保存
      this.$store.commit("setTargetBranch", branch); // クリックした区別をstoreに保存
      this.$store.commit("setTargetBranchName", branchName); // クリックした区別名をstoreに保存
      this.$store.commit("setTargetAddress", address); // クリックした所在地をstoreに保存

      // 同タブで開く
      this.$router.push({ name: name });
    },

    // 区別追加
    async addBranch(index, item) {
      Debug.log('addBranch');

      // 事業所の最後に追加
      // const branchCount = this.officeList.filter(function(el){
      //   return el.memberNo == item.memberNo;
      // }).length;

      // 事業所の最大区別
      const lastBranch = this.getLastBranch(item.memberNo);

      let tmpAddItem = Object.assign({}, item);
      tmpAddItem.status = 0;
      tmpAddItem.branch = lastBranch+1;
      tmpAddItem.branchName = null;
      tmpAddItem.branchEdit = true;
      tmpAddItem.address = item.address;

      // DB保存
      this.saveBranch(tmpAddItem);

      //this.officeList.splice(index+branchCount, 0, tmpAddItem);
    },
    // 区別保存
    async saveBranch(item) {
      Debug.log('saveBranch');
      this.loading = true;
      try {
        await RefrigerantAnswer.setBranch(item);
      } catch (error) {
        Message.err(error, "区別を保存できませんでした");
      }

      item.branchEdit = false;
      this.loading = false;

      this.search();
    },
    // 区別削除
    async deleteBranch(item) {
      Debug.log('deleteBranch');

      if (!confirm("回答データは削除されます。よろしいですか？")) return;

      this.loading = true;
      try {
        await RefrigerantAnswer.delBranch(item.sid, item.memberNo, item.branch);
      } catch (error) {
        Message.err(error, "区別を削除できませんでした");
      }

      item.branchEdit = false;
      this.loading = false;

      this.search();
    },

    // 事業所の最小の区分
    getFirstBranch(memberNo) {
      Debug.log('getFirstBranch');
      const member = this.officeList.filter(function(el){
        return el.memberNo == memberNo;
      });

      // 区分のみを配列で取得
      const branchList = member.map(function (b) {
        return b.branch;
      });

      // 最小値を取得
      return Math.min.apply(null, branchList);
    },
    // 事業所の最大の区分
    getLastBranch(memberNo) {
      Debug.log('getLastBranch');
      const member = this.officeList.filter(function(el){
        return el.memberNo == memberNo;
      });

      // 区分のみを配列で取得
      const branchList = member.map(function (b) {
        return b.branch;
      });

      // 最大値を取得
      return Math.max.apply(null, branchList);
    },

    // ステータス一括変更保存
    async saveBulkStatus() {
      const updateList = this.filterItems;
      // 事業所数のみ集計
      const uniqueMemberCount = new Set(updateList.map(item => item.memberNo)).size;
 
      if (!confirm(updateList.length + "件の事業所区別のステータスを変更します。よろしいですか？\n(事業所数:" + uniqueMemberCount + "件)")) return;
 
      this.loading = true;
      try {
        // ステータス変更
        await RefrigerantAnswer.updateBulkStatus(updateList, this.bulkStatus);
        alert(updateList.length + "件のステータスを変更しました。");
 
        // モーダルを閉じてから一覧再検索
        this.loading = false;
        this.hideChangeStatus();
        this.search();
      } catch (error) {
        Message.err(error, "ステータスを変更できませんでした");
      }
    },

    // ステータスのフィルター
    customFilter(value, search){
      return typeof value === 'number' && this.getAnsStatusText(value) == search;
    },

    // 回答受付期間一括変更保存
    async saveBulkAnsPeriod() {
      const updateList = this.filterItems;
 
      if(this.checkStartEndDate(this.bulkAnsPeriodFrom, this.bulkAnsPeriodTo) !== true) {
        alert("回答受付期間を正しく入力してください。");
        return;
      } 
 
      // 事業所数のみ集計
      const uniqueMemberCount = new Set(updateList.map(item => item.memberNo)).size;
      if (!confirm(uniqueMemberCount + "件の事業所の回答受付期間を変更します。よろしいですか？\nこの変更は、関連する区別にも反映されます。")) return;
 
      this.loading = true;
      try {
        // 回答受付期間変更
        await RefrigerantDest.updateBulkAnsPeriod(updateList, this.bulkAnsPeriodFrom, this.bulkAnsPeriodTo);
        alert(uniqueMemberCount + "件の事業所の回答受付期間を変更しました。");
 
        // モーダルを閉じてから一覧再検索
        this.loading = false;
        this.hideChangeAnsPeriod();
        this.search();
      } catch (error) {
        Message.err(error, "回答受付期間を変更できませんでした");
      }
    },

    /** 回答受付期間一括変更 */
    showChangeAnsPeriod () {
      Debug.log('function[showChangeAnsPeriod]');
 
      if (this.filterItems.length <= 0) {
        alert("変更対象のデータがありません。");
        return;
      }
 
      // 回答受付期間開始 の最も古い日付、回答受付期間終了 の最も新しい日付を設定
      const fromDates = this.filterItems
        .map(item => dayjs(item.ansPeriodFrom))
        .filter(d => d.isValid());
      const toDates = this.filterItems
        .map(item => dayjs(item.andPeriodTo))
        .filter(d => d.isValid());
 
      if (fromDates.length > 0) {
        const minFrom = fromDates.reduce((a, b) => (a.isBefore(b) ? a : b));
        this.bulkAnsPeriodFrom = minFrom.format('YYYY-MM-DD');
      }
 
      if (toDates.length > 0) {
        const maxTo = toDates.reduce((a, b) => (a.isAfter(b) ? a : b));
        this.bulkAnsPeriodTo = maxTo.format('YYYY-MM-DD');
      }
 
      this.$modal.show('change-ans-period-modal-dialog');
    },
    hideChangeAnsPeriod : function () {
      Debug.log('function[hideChangeAnsPeriod]');
      this.bulkAnsPeriodFrom = null;
      this.bulkAnsPeriodTo = null;
      this.$modal.hide('change-ans-period-modal-dialog');
    },

    /** ステータス一括変更 */
    showChangeStatus () {
      Debug.log('function[showChangeStatus]');
 
      if (this.filterItems.length <= 0) {
        alert("変更対象のデータがありません。");
        return;
      }
 
      this.$modal.show('change-status-modal-dialog');
    },
    hideChangeStatus : function () {
      Debug.log('function[hideChangeStatus]');
      this.bulkStatus = null;
      this.$modal.hide('change-status-modal-dialog');
    },

    /** 冷媒調査集計 */
    async getRefrigerantDB() {
      try {
        this.actionMessage = "冷媒調査集計を作成しています。\nしばらくお待ちください。"
        this.$modal.show('modal-dialog');

        const res = await Refrigerant.sumRefrigerantDB(this.searchCondition);

        if (res.status == 200 && res.data) {
          // 作成に成功したらExcelダウンロード
          Debug.log(res.data);
          const downloadFile = res.data;
          Download.download(downloadFile)
            .then(res => {
              const targetYearStr = dayjs(this.searchCondition.targetYear).format('YYYY');
              saveAs(res.data, '冷媒調査集計('+targetYearStr+'版).xlsx');
            })
            .catch((err) => {
              Message.err(err, "ダウンロードできませんでした");
          })
        }
      } catch (error) {
        Message.err(error, "冷媒調査集計を作成できませんでした");
      } finally {
        this.$modal.hide('modal-dialog');
      }
    },
  },

  filters: {
    formatDate(date) {
      // YYYY/MM/DD になおす
      if (!date) return "";
      const formatDate = dayjs(date);

      const dayOfWeek = ["日", "月", "火", "水", "木", "金", "土"][formatDate.day()];

      return `${formatDate.format("YYYY/MM/DD")}(${dayOfWeek})`;
    },
  },

  computed: {
    filterItems() {
      if (this.officeList.length > 0) {
        return this.$refs.ref.$children[0].filteredItems;
      } else {
        return [];
      }
    },

    modalWidth() {
      return this.$vuetify.breakpoint.mdAndDown ? '80%' : '50%';
    },
  }
};
</script>

<style scoped>
.disablecolor {
  background: #bbbbbb;
}

/* ぐるぐる */
.action-message {
  white-space: pre-line;
}
.spinner {
  margin: 50px;
}

/* 列固定、他 */
.sticky_table >>> .v-data-table__wrapper {
  max-height: calc(100vh - 200px);
}
.sticky_table >>> th,
.sticky_table >>> td {
	min-width: 80px;
  padding: 0 5px  !important;
  z-index: 1;
}
 
/* ここから固定用のコード */
.sticky_table >>> th:nth-child(1) {
	left: 0;
  z-index: 5;
}
.sticky_table >>> th:nth-child(2) {
	left: 80px;
  z-index: 5;
}
.sticky_table >>> th:nth-child(3) {
	left: 160px;
  z-index: 5;
}
.sticky_table >>> th:nth-child(4) {
	left: 310px;
  z-index: 5;
}
 
.sticky_table td:nth-child(1) {
	position: -webkit-sticky;
	position: sticky;
  background-color: white;
	left: 0;
  width: 80px;
}
.sticky_table td:nth-child(2) {
	position: -webkit-sticky;
	position: sticky;
  background-color: white;
	left: 80px;
  width: 80px;
}
.sticky_table td:nth-child(3) {
	position: -webkit-sticky;
	position: sticky;
  background-color: white;
	left: 160px;
  width: 150px;
}
.sticky_table td:nth-child(4) {
	position: -webkit-sticky;
	position: sticky;
  background-color: white;
	left: 310px;
  width: 150px;
}
 
/* hover の設定を行う */
.sticky_table tr:hover {
	background-color: var(--v-table_hover-base);
}
.sticky_table tr:hover > td {
	background-color: var(--v-table_hover-base);
}

/* モーダル */
.modal-wrap {
  height: 100%;
}
.modal-header {
  height: 10%;
}
.modal-header h2 {
  align-items: center;
  display: inline-flex;
}
.modal-body {
  overflow-y: scroll;
  height: 90%;
}
</style>
